import React from 'react';

export default function FAQSection() {
  return (
    <div className="py-20 bg-black/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-300">Everything you need to know about Poppy Poker</p>
        </div>
        
        <div className="space-y-6">
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-purple-400 mb-4">How does the synchronization work?</h3>
            <p className="text-gray-300">One person starts a game timer, and all other players with the app installed automatically receive the game information. No QR codes or configuration needed - it just works when devices are in close proximity to the hosting venue.</p>
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-purple-400 mb-4">Is Poppy Poker free to use?</h3>
            <p className="text-gray-300">Yes! Poppy Poker is completely free to download and use. All core features are available at no cost to help build the poker community.</p>
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-purple-400 mb-4">What devices are supported?</h3>
            <p className="text-gray-300">Poppy Poker is available for both iOS (iPhone/iPad) and Android devices. The app works on all modern smartphones and tablets.</p>
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-purple-400 mb-4">How do I find games in my area?</h3>
            <p className="text-gray-300">Simply enable GPS on your device and open the app. Poppy Poker will automatically show you nearby games within a 200-mile radius. You can also search for specific venues or game types.</p>
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-purple-400 mb-4">Can I host my own games?</h3>
            <p className="text-gray-300">Absolutely! You can create and host your own poker games. Set up the timer, invite players, and manage your game with ease. Perfect for home games, club tournaments, and special events.</p>
          </div>
          
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-purple-400 mb-4">Is my data secure?</h3>
            <p className="text-gray-300">Yes, we take privacy and security seriously. All user data is encrypted and stored securely. We never share your personal information with third parties.</p>
          </div>
        </div>
      </div>
    </div>
  );
}


